import { useGetAllHostEventsQuery } from "../../redux/api/eventApi";
import Card from "../Card";

type Props = {};

const AllTickets = (props: Props) => {
  const { data, isLoading, error } = useGetAllHostEventsQuery();

  if (isLoading) return <p>Loading events...</p>;
  if (error) return <p>Failed to load events.</p>;

  return (
    <Card title="All Events" data={data?.data ?? []} loading={isLoading} />
  );
};

export default AllTickets;
